/* lua.js generated code 0.3.0 */

var UserLevelUtil = require("clover/logic/userLevel/UserLevelUtil")
var UserLevelTypeBase = xClass("UserLevelTypeBase")

let passLevelRetry = 0
let passLevelRetryMax = 3

UserLevelTypeBase.prototype.ctor = function () {}
UserLevelTypeBase.prototype.canStartLevel = function (levelId, itemList, ) {
    return [false, ZooErrorCode.UNDEFINED_LEVEL_TYPE]
}
UserLevelTypeBase.prototype.getConsumeEnergy = function (levelId) {
    return 0
}
// 关前道具做了一些扩充
UserLevelTypeBase.prototype.isExtraPreProp = function (propItemId) {
    let self = this
    if (propItemId === GamePropsType.kAdd3_b_t_limited || propItemId === GamePropsType.kAdd3_b_t_unlimited || propItemId === GamePropsType.kLine_Wrap_b_t_limited || propItemId === GamePropsType.kLine_Wrap_b_t_unlimited || propItemId === GamePropsType.kSuperBird_b_t_limited || propItemId === GamePropsType.kSuperBird_b_t_unlimited 
        || propItemId === GamePropsType.kAdd3_limited || propItemId === GamePropsType.kLine_Wrap_limited || propItemId === GamePropsType.kSuperBird_limited) {
        return true
    }
    return false
}
UserLevelTypeBase.prototype.canStartLevel_checkInitProp = function (levelId, itemList) {
    var gameMode = LevelConfigManager.getInstance().getLevelGameMode(levelId)
    if (!gameMode) {
        return [false, ZooErrorCode.STAGE_INFO_NOT_EXIST]
    }
    var [propMeta, initPropList] = [MetaManager.getGameModePropByModeId(gameMode), table()]
    let infiPropState = UserManager.getInstance().isInfiPrePropState(levelId)
    for (var i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
        if (!table.indexOf(propMeta.initProps || table(), v) && !self.isExtraPreProp(v)) {
            return [false, ZooErrorCode.ADD_PROP_MODE_ERROR_START_LEVEL]
        }
        if (UserProp.getInstance().getAvaliablePropNumber(v) < 1 && (!infiPropState && UserPropData.isLitmitedPreProp(v))) {
            table.insert(initPropList, v)
        }
    }
    for (var i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
        if (ItemType.isPassLevelPropLock(v, levelId)) {
            return [false, ZooErrorCode.USE_PRE_PROP_NOT_PASS_LEVEL]
        }
    }
    var [needCoin, needCash] = [0, 0]
    for (var i = 1, v = initPropList[1]; v; i++, v = initPropList[i]) {
        var goodsId = UserDealData.getGoodsIdForProp(v)
        var discountGoodsId = UserDealData.getDiscountGoodsIdIfAvaliable(goodsId, 1)
        if (discountGoodsId) {
            goodsId = discountGoodsId
        }
        var [success, errCode] = UserDeal.getInstance().canBuyGoods(goodsId, 1)
        if (!success) {
            return [false, errCode]
        }
        var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
        var payType = UserDealData.getGoodsPayType(goodsId)
        if (payType === UserDealPayType.kCoin) {
            needCoin = needCoin + goodsMeta.coin
        } else if (payType === UserDealPayType.kCash) {
            needCash = needCash + (goodsMeta.discountQCash !== 0 && goodsMeta.discountQCash || goodsMeta.qCash)
        } else {
            return [false, ZooErrorCode.BUY_WRONG_MONEY_TYPE]
        }
    }
    if (!UserCoin.getInstance().checkCoin(needCoin)) {
        return [false, ZooErrorCode.COIN_NOT_ENOUGH]
    }
    if (!UserCash.getInstance().checkCash(needCash)) {
        return [false, ZooErrorCode.CASH_NOT_ENOUGH]
    }
    return [true, undefined]
}
UserLevelTypeBase.prototype.ctor = function (levelId, itemList) {
    let self = this
    let propId;
    itemList = itemList || table()
    self.levelId = levelId
    self.levelType = 0
    let gameMode = LevelConfigManager.getInstance().getLevelGameMode(levelId)
    self.startTime = Localhost.time()
    self.initProps = table()
    for (let i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
        self.initProps[v] = (self.initProps[v] || 0) + 1
    }
    self.ingameProps = table()
    let propMeta = MetaManager.getGameModePropByModeId(gameMode)
    propMeta = propMeta || table([1, "ingameProps", table()], [1, "finalProps", table()])
    let userLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    for (let i = 1, v = propMeta.ingameProps[i]; v; i++, v = propMeta.ingameProps[i]) {
        let unlockLevel = (MetaManager.getInstance().getPropMeta(propId) || table()).unlock || 0
        if (userLevel >= unlockLevel) {
            self.ingameProps[v] = 0
        }
    }
    self.finalProps = table()
    for (let i = 1, v = propMeta.finalProps[1]; v; i++, v = propMeta.finalProps[i]) {
        let unlockLevel = (MetaManager.getInstance().getPropMeta(propId) || table()).unlock || 0
        if (userLevel >= unlockLevel) {
            self.finalProps[v] = 0
        }
    }
    self.infiProps = table()
}

UserLevelTypeBase.prototype.resetInGameProps = function () {
    let self = this
    self.ingameProps = table()
    let propMeta = self.getPropMeta()
    let userLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    let $st42 = (propMeta || table()).ingameProps || table()
    for (let i = 1, v = $st42[1]; v; i++, v = $st42[i]) {
        let unlockLevel = (MetaManager.getInstance().getPropMeta(null) || table()).unlock || 0
        if (userLevel >= unlockLevel) {
            self.ingameProps[v] = 0
        }
    }
}

UserLevelTypeBase.prototype.getPropMeta = function() {
    var self = this;
	var gameMode = LevelConfigManager.getInstance().getLevelGameMode(self.levelId);
	var propMeta = MetaManager.getGameModePropByModeId(gameMode);
	return propMeta
}

UserLevelTypeBase.prototype.startLevel = function (levelId, itemList, successCallback, failCallback, cancelCallback, otherData, adPropIds) {
    var self = this

    function onSuccess(event) {
        let userExtend = UserManager.getInstance().getUserExtendRef()
        let now = Localhost.time()
        let lastBuffTime = parseInt(userExtend.getNotConsumeEnergyBuff());
        let star = UserScore.getInstance().getScore(levelId).star || 0;
        //检查当前玩家是否为无限精力状态,以及是否闯关过，防止有未解锁时，最大关为当前关
        if (lastBuffTime < now && star == 0) {
            const isMystery = LevelType.isMysteryIslandLevel(levelId);
            console.log("关末加步数策略优化:levelId "  + levelId , isMystery);
            if(levelId == UserManager.getInstance().user.topLevelId || isMystery) {
                UserManager.getInstance().addTopLevelFailTimes(levelId);
            }
        }
        if(lastBuffTime > now) {
            //只在无限精力时，设置为不消耗精力，其他情况在其他地方处理
            UserManager.getInstance().setConsumeEnergy(false);
        }

        if (successCallback) {
            UserManager.getInstance().setInNewLevelEnd(event.data.inNewLevleEnd);
            successCallback(event)
        }
    }
    function onFail(event) {
        if (failCallback) {
            failCallback(event)
        }
    }
    function onCancel() {
        if (cancelCallback) {
            cancelCallback()
        }
    }

    var energyFlag = 0
    //console.log("[monthticket] userleveltypebase")
    // if (UserManager.getInstance().isHaveEquityMonthTicket(true)){
    //     energyFlag = 2
    // }
    // 关卡开始和结束增加后端点位，需要再开始结束关卡请求前初始化DCAssist.playLevelSession
    DCAssist.setPlayLevelSession()
    var http = StartLevelHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(levelId, itemList, UserEnergy.getInstance().getEnergyInfinity()[0], self.levelType, otherData, adPropIds, energyFlag)
}
UserLevelTypeBase.prototype.startLevel_buyInitProp = function (levelId, itemList, onSuccess, onFail) {
    let self = this
    let infiPropState = UserManager.getInstance().isInfiPrePropState(levelId)
    if (infiPropState) {
        for (let i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
            // var
            let goodsId = UserDealData.getGoodsIdForProp(v)
            BuyHttp.new().load(goodsId, 1, 1, goodsId, levelId)
            UserProp.getInstance().addProp(v, 1, null, null, ModuleName.BUY_GAME_COINS, levelId)
        }
        return
    }
    var need_req_count = 0
    var not_need_req_count = 0
    var fail_falg = false
    // 等待多个购买物品请求返回
    // 有一个失败，后续不再请求，调用失败回调
    if ($len(itemList) === 0) {
        onSuccess && onSuccess()
        return
    }
    for (var i = 1, v = itemList[1]; v; i++, v = itemList[i]) {
        if (UserProp.getInstance().getAvaliablePropNumber(v) < 1) {
            if (fail_falg) {
                onFail && onFail()
                return
            }
            need_req_count = need_req_count + 1
            // 极端情况下网络请求时间 == 同步调用函数的时间会有问题
            function callback() {
                need_req_count = need_req_count - 1
                if (need_req_count <= 0) {
                    onSuccess && onSuccess()
                    return
                }
            }
            function req_fail() {
                fail_falg = true
                return
            }
            var goodsId = UserDealData.getGoodsIdForProp(v)
            var discountGoodsId = UserDealData.getDiscountGoodsIdIfAvaliable(goodsId, 1)
            if (discountGoodsId) {
                goodsId = discountGoodsId
            }
            // 开始关卡时已经检查过是否可以买道具了，因此这里不再关心购买结果，直接进入下一步。
            UserDeal.getInstance().buyGoods(goodsId, 1, null, null, null, callback, req_fail, req_fail, ModuleName.STAGE_START)
        }else{
            not_need_req_count = not_need_req_count + 1
            if (not_need_req_count === $len(itemList)) {
                onSuccess && onSuccess()
            }
        }
    }
}
UserLevelTypeBase.prototype.pushInitProp = function (propId) {
    let self = this
    self.initProps[propId] = 1
}
UserLevelTypeBase.prototype.canUseProp = function () {
    var self = this
    return [false, ZooErrorCode.USE_PROP_RANGE_ERROR]
}
UserLevelTypeBase.prototype.canUseProp_checkRange = function (propId) {
    var self = this
    if (self.initProps[propId] != undefined && self.ingameProps[propId] != undefined && self.finalProps[propId] != undefined) {
        return [false, ZooErrorCode.USE_PROP_RANGE_ERROR]
    }
    return [true]
}
UserLevelTypeBase.prototype.canUseProp_checkUseTime = function (propId, num) {
    var self = this
    // 激活超鸟 可去除道具限制
    if(NuclearBirdManager.getInstance().isRunNuclear){
        return [true]
    }
    // 月票权益卡 可去除道具限制
    // if (UserLevel.getInstance().isHaveEquityMonthTicket()){
    //     return [true]
    // }
    if (UserPropData.isTempProp(propId) || UserPropData.isInfiniteProp(propId)) {
        return [true]
    }
   propId = UserPropData.getPermanentPropId(propId)
    var maxTime = MetaManager.getInstance().getMaxUseTime(self.levelId, propId)
    if (!window.unLimitUserProp && self.ingameProps[propId] && maxTime !== 0 && maxTime < self.ingameProps[propId] + num) {
        return [false, ZooErrorCode.USE_PROP_OVER_LIMIT_IN_GAME]
    } else {
        return [true]
    }
}
UserLevelTypeBase.prototype.useProp = function (propId, num) {
    var self = this
    // 临时道具不计入使用次数
    if (UserPropData.isInfiniteProp(propId) || UserPropData.isTempProp(propId) || UserPropData.isAdProp(propId)) {
        return 
    }
    propId = UserPropData.getPermanentPropId(propId)
    if (type(self.ingameProps[propId]) === "number") {
        self.ingameProps[propId] = self.ingameProps[propId] + num
        return 
    }
    if (type(self.finalProps[propId]) === "number") {
        self.finalProps[propId] = self.finalProps[propId] + num
    }
}
UserLevelTypeBase.prototype.useInfiProp = function (propId) {
    let self = this
    if (UserPropData.isInfiniteProp(propId)) {
        self.infiProps[propId] = (self.infiProps[propId] || 0) + 1
        return 
    }
}
UserLevelTypeBase.prototype.getInfiPropUseCount = function (propId) {
    let self = this
    return self.infiProps[propId] || 0
}
UserLevelTypeBase.prototype.endLevel = function (score, star, stageTime, coin, targetCount, opLog, costMove, successCallback, failCallback, cancelCallback, cleanRetry) {
    var self = this
    self.sendEndRequest(score, star, stageTime, coin, targetCount, opLog, costMove, successCallback, failCallback, cancelCallback, cleanRetry)
}

UserLevelTypeBase.prototype.sendEndRequest = function (score, star, stageTime, coin, targetCount, opLog, costMove, replay, successCallback, failCallback, cancelCallback, otherData, cleanRetry = true) {
    var self = this
    otherData = otherData || {}
    if (cleanRetry){
        passLevelRetry = 0
    }
    // body
    function onSuccess(event) {
        passLevelRetry = 0
        if (successCallback) {
            successCallback(event)
        }
    }
    function onFail(event) {
        if (event && parseInt(event.data) == ZooErrorCode.LEVEL_ID_INVALID){
            // 关卡错误的情况不重试了
            passLevelRetry = 0
            if (failCallback) {
                failCallback(event)
            }
        }else{
            // 可能是超时重试2次
            passLevelRetry += 1
            if (passLevelRetry <= passLevelRetryMax){
                let errorStr = ""
                if (event){
                    errorStr = event.data ? event.data : event
                    if(event.code) errorStr += "code "+ event.code
                    if(event.context) errorStr += "context "+ event.context
                }
                LogToLogCenter(new Error(`passlevel error, auto retry:${passLevelRetry}, error: ${errorStr}`))
                self.sendEndRequest(score, star, stageTime, coin, targetCount, opLog, costMove, replay, successCallback, failCallback, cancelCallback, otherData, false)
                return
            }else{
                if (self.loadingPanelId){
                    LoadingPanelLogic.getInstance().remove(self.loadingPanelId)
                }
                // 自动的3次重试都失败了，提示玩家是不是要继续重试
                require("clover/sns/SnsProxy").getInstance().showDialog({
                    text : "网络连接失败，请重试",
                    needOkBtn : true,
                    okBtnText : "重试",
                }, () => {
                    passLevelRetry = 0
                    let errorStr = ""
                    if (event){
                        errorStr = event.data ? event.data : event
                        if(event.code) errorStr += "code "+ event.code
                        if(event.context) errorStr += "context "+ event.context
                    }
                    LogToLogCenter(new Error(`passlevel error, click retry:${passLevelRetry}, error: ${errorStr}`))
                    self.sendEndRequest(score, star, stageTime, coin, targetCount, opLog, costMove, replay, successCallback, failCallback, cancelCallback, otherData, false)
                })
                return
            }
            // passLevelRetry = 0
            // if (failCallback) {
            //     failCallback(event)
            // }
        }
    }
    function onCancel() {
        passLevelRetry = 0
        if (cancelCallback) {
            cancelCallback()
        }
    }
    var http = PassLevelHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(self.levelId, score, star, stageTime, coin, targetCount, opLog, self.levelType, costMove, replay, otherData)
}
UserLevelTypeBase.prototype.endLevel_removeTempProp = function () {
    var self = this
    for (var k in self.tmpProps) {
        var v = self.tmpProps[k]
        UserManager.getInstance().addUserPropNumber(k, -v)
    }
}
UserLevelTypeBase.prototype.endLevel_addReward = function (scoreRef, oldScoreRef) {
    var self = this
    var reward = UserLevelUtil.calcPassLevelRewardItems(self.levelId, scoreRef, oldScoreRef)
    for (var i = 1, v = reward[1]; v; i++, v = reward[i]) {
        UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.STAGE_REWARD)
    }
    return reward
}
UserLevelTypeBase.prototype.getHasUsedProps = function () {
    var self = this
    return $len(self.finalProps) > 0
}
UserLevelTypeBase.prototype.getUsedTime = function () {
    var self = this
    return Localhost.time() - self.startTime
}
module.exports = UserLevelTypeBase
